import { render, staticRenderFns } from "./PointsPage.vue?vue&type=template&id=2a7072ea&"
import script from "./PointsPage.vue?vue&type=script&lang=js&"
export * from "./PointsPage.vue?vue&type=script&lang=js&"
import style0 from "./PointsPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports